if (!customElements.get('hydros-product-switcher')) {
  customElements.define(
    'hydros-product-switcher',
    class HydrosProductSwitcher extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-home-slide]')];
        this.tabs = [...this.querySelectorAll('[data-home-slide-button]')];
        this.pauseButton = this.querySelector('[data-home-pause]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.userPaused = false;

        this.handleTabClick = (event) => this.show(event.currentTarget.dataset.homeSlideButton);
        this.handlePauseClick = () => this.togglePause();
        this.handleMouseEnter = () => this.stopTimer();
        this.handleMouseLeave = () => this.schedule();
        this.handleFocusIn = () => this.stopTimer();
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.schedule();
        };
        this.handleVisibility = () => {
          if (document.hidden) this.stopTimer();
          else this.schedule();
        };

        this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
        this.pauseButton?.addEventListener('click', this.handlePauseClick);
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.show(this.slides[this.index]?.dataset.homeSlide || 'hynox', false);
        this.schedule();
      }

      show(name, restart = true) {
        const nextIndex = this.slides.findIndex((slide) => slide.dataset.homeSlide === name);
        if (nextIndex < 0) return;

        this.index = nextIndex;
        this.dataset.activeProduct = name;

        this.slides.forEach((slide, index) => {
          const active = index === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.tabs.forEach((tab) => {
          const active = tab.dataset.homeSlideButton === name;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        if (restart) this.schedule();
      }

      advance() {
        const next = (this.index + 1) % this.slides.length;
        this.show(this.slides[next].dataset.homeSlide);
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.classList.toggle('is-paused', this.userPaused);
        this.pauseButton?.setAttribute('aria-label', this.userPaused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
        this.pauseButton?.setAttribute('title', this.userPaused ? 'Lecture' : 'Pause');
        if (this.userPaused) this.stopTimer();
        else this.schedule();
      }

      stopTimer() {
        window.clearTimeout(this.timer);
      }

      schedule() {
        this.stopTimer();
        if (this.userPaused || this.motionQuery.matches || this.slides.length < 2 || document.hidden) return;
        this.timer = window.setTimeout(() => this.advance(), 7000);
      }

      disconnectedCallback() {
        this.stopTimer();
        this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
        this.pauseButton?.removeEventListener('click', this.handlePauseClick);
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }
    }
  );
}
